import VideoTutorial from './VideoTutorial';

export default VideoTutorial;
